import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useToast } from 'context/ToastContext.js';
import { useLeadContext } from 'modules/lead/Context/LeadContext';
import { convertToCase } from 'services/lead/leadServices';
import { toastConstant } from 'constants/toastmessage';
import { formatPaymentStructure } from 'modules/lead/helpers/helpers';
import { useToggle } from 'hooks/useToggle';
import { flatFee, subscription } from 'constants/index';

const useConvertCaseForm = ({ onHide, leadDetails }) => {
  const { paymentStructures } = useLeadContext();
  const [loading, setLoading] = useToggle(false);
  const { addToast } = useToast();
  const history = useHistory();

  const { control, ...formProps } = useForm();

  useEffect(() => {
    formProps.reset(formatPaymentStructure(leadDetails));
  }, []);

  const updateLeadData = (data, sendPayReq) => {
    if (data && data?.billing_preferences) {
      setLoading();
      const { billing_preferences, case_description, case_contact, case_relation, case_id, online_lead_fields } = data || {};
      const _billPref = { ...billing_preferences };
      if (_billPref?.subscriptionDates?.length > 1) {
        _billPref.start_date = _billPref?.subscriptionDates?.[0];
        _billPref.end_date = _billPref?.subscriptionDates?.[1];
        _billPref.rate = String(_billPref?.rate);
        _billPref.frequency_of_payment = 'monthly';
      }
      convertToCase(data.sk, { billing_preferences: _billPref, case_description, case_contact, case_relation, online_lead_fields })
        .then(() => {
          onHide('converted');
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.LEAD_CONVERT_SUCCESS);
          if (sendPayReq && case_id) {
            if (
              subscription === billing_preferences?.payment_structure?.toLowerCase() ||
              billing_preferences?.payment_structure?.toLowerCase() === flatFee
            ) {
              localStorage.setItem('redirectToInvoice', true);
              history.push(`/cases/${case_id}/billing`, { redirectPR: false, redirectInvoice: true });
            } else {
              localStorage.setItem('redirectToRequestPayment', true);
              localStorage.setItem('requestPaymentAmount', data?.billing_preferences?.rate || data?.billing_preferences?.retainer_amount);
              history.push(`/cases/${case_id}/billing`, { redirectPR: true, redirectInvoice: false });
            }
          }
        })
        .catch(() => {
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.LEAD_CONVERT_FAILURE);
        })
        .finally(() => setLoading());
    }
  };

  return { paymentStructures, control, formProps, loading, updateLeadData };
};

export default useConvertCaseForm;
